// Module
var code = "<style></style> <select id=\"pump-select\"></select>";
// Exports
export default code;